import React, { RefObject, useEffect } from 'react';
import { Notifications } from 'new/elements/Notifications/Notifications';
import { fetchResourceNotificationsPaginated } from 'js/actions';
import { useDispatch } from 'react-redux';
import { useResourceNotifications } from 'new/hooks/adapters/useResourceNotifications';

interface ResourceNotificationsProps {
  data?: any;
  notificationType: string;
  parentScrollRef?: RefObject<any>;
}

export const ResourceNotifications = (props: ResourceNotificationsProps) => {
  const { data, notificationType, parentScrollRef } = props;
  const dispatch = useDispatch();
  const { meta } = useResourceNotifications(notificationType, data.id);
  const { perPageCount, sortOrder } = meta;
  useEffect(() => {
    dispatch(
      fetchResourceNotificationsPaginated(data.id, props.notificationType, {
        page: 1,
        per_page: perPageCount || 100,
        sort_order: sortOrder || 'DESC',
        sort_by: 'created_at',
      }),
    );
  }, []);

  return (
    <Notifications
      notificationType={props.notificationType}
      resourceId={data.id}
      parentScrollRef={parentScrollRef}
    />
  );
};
